import { employeeApi } from '../ShiftManagement/employeeApi';

export const DEFAULT_EMPLOYEE_STATUS = {
  status: 'available',
  statusMessage: 'Available',
  isAvailable: true,
};

export const getEmployeeStatusColorClass = status => {
  switch (status) {
    case 'on_leave':
      return 'text-orange-600';
    case 'assigned_to_shift':
    case 'local_conflict':
      return 'text-red-600';
    default:
      return 'text-green-600';
  }
};

const getEmployeeUserId = employee => employee?.user_id || employee?.employee_id;

/**
 * Validates leave and shift conflicts for each employee against the scheduled date/time.
 */
export const validateEmployeesAvailability = async (employees, shiftValidationData) => {
  if (!shiftValidationData?.date || !Array.isArray(employees) || employees.length === 0) {
    return {};
  }

  const { date, startTime, endTime } = shiftValidationData;
  const statuses = {};

  await Promise.all(
    employees.map(async employee => {
      const userId = getEmployeeUserId(employee);
      if (!userId) return;

      try {
        let isOnLeave = false;
        try {
          const leaveAvailability = await employeeApi.checkLeaveAvailability({ userId, date });
          isOnLeave = !leaveAvailability.available;
        } catch {
          isOnLeave = false;
        }

        let isAssignedToShift = false;
        if (startTime && endTime) {
          try {
            isAssignedToShift = await employeeApi.isUserAssignedToShift({
              userId,
              date,
              startTime,
              endTime,
            });
          } catch {
            isAssignedToShift = false;
          }
        }

        let status = 'available';
        let statusMessage = 'Available';
        let isAvailable = true;

        if (isOnLeave) {
          status = 'on_leave';
          statusMessage = 'On leave';
          isAvailable = false;
        } else if (isAssignedToShift) {
          status = 'assigned_to_shift';
          statusMessage = 'Assigned to another shift';
          isAvailable = false;
        }

        statuses[userId] = { status, statusMessage, isAvailable };
      } catch {
        statuses[userId] = { ...DEFAULT_EMPLOYEE_STATUS };
      }
    })
  );

  return statuses;
};
